import { useContext, useEffect, useState } from "react";
import { TranslateContext } from "../widgets/MyDataHelps/TranslateContext";

export default function useTranslate(stringKeys: string[]) {
    const translate = useContext(TranslateContext);
    let emptyStrings = new Map(
        stringKeys.map(p => [p, ""])
    );

    let [strings, setStrings] = useState<Map<string, string>>(emptyStrings);

    useEffect(() => {
        const translateText = async () => {
            let promises = stringKeys.map(key => translate(key));
            Promise.all(promises)
                .then((strings) => {
                    setStrings(new Map(
                        stringKeys.map((key, i) => [key, strings[i]])
                    ));
                }).catch((e) => {
                    console.error("Error loading translations for keys: ", JSON.stringify(stringKeys));
                });
        }
        translateText();
    }, [translate.use()]);

    return Object.fromEntries(strings);
}